import * as React from "react"
import Seo from "@shared/head/Seo"
import Layout from "@app/Layout"
import { Hero } from "@shared/ui"
import { Col, Container, Row } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"
import { graphql } from "gatsby"

interface GlossaryItem {
  pageTitle: string
  url: string
}
interface Glossary {
  data: GlossaryItem[]
}
interface QueryData {
  allBuilderModels: {
    glossary: Glossary[]
  }
}

// SEO Meta
export const Head = () => (
  <Seo title="Словарь маркетолога от Carrot quest" description="Термины для digital-специалистов и макетологов с понятными объяснениями. Все нужные понятия и расшифровки для ежедневной работы без ошибок и недопонимания." path="/glossary/">
  </Seo>
)

export default function GlossaryCQ({ data }: { data: QueryData }) {
  const liters = content(data.allBuilderModels.glossary)

  return (
    <Layout className="page">
      <Hero>
        <Col lg={6}>
          <h1>Словарь маркетолога</h1>
          <p>
            Содержит ключевые термины и определения, используемые в сфере маркетинга и продаж. Словарь состоит из разделов по различным аспектам маркетинга,
            таким как цифровой маркетинг, контент-маркетинг, email-маркетинг и другие.
          </p>
        </Col>
        <Col lg={4} xl={6} className="text-center py-5 order-1 order-md-2">
          <StaticImage src="./images/hero.png" width={600} className="mw-100" alt="Словарь маркетолога" loading="eager" />
        </Col>
      </Hero>

      <section>
        <Container>
          <Row>
            <Col>
              {Object.keys(liters).map((liter) => {
                return (
                  <div key={liter} className="mb-5">
                    <h3>{liter}</h3>
                    {liters[liter].map((item) => (
                      <p key={item.url}>
                        <a href={`/glossary${item.url}/`}>{item.pageTitle}</a>
                      </p>
                    ))}
                  </div>
                )
              })}
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  )
}

export const query =
  !+process.env.GATSBY_DASHLY &&
  graphql`
    query MyQuery {
      allBuilderModels {
        glossary(limit: 1000) {
          data {
            url
            pageTitle
          }
        }
      }
    }
  `

function content(glossary: Glossary[]) {
  const result: { [key: string]: GlossaryItem[] } = {}
  glossary.forEach(({ data }: any) => {
    const key = isEnglishLetter(data.pageTitle[0]) ? "A-Z" : data.pageTitle[0].toUpperCase()

    if (typeof result[key] === "undefined") {
      result[key] = [data]
    } else {
      result[key].push(data)
      result[key].sort(function (a, b) {
        return a.pageTitle.localeCompare(b.pageTitle)
      })
    }
  })

  const sortedKeys = Object.keys(result).sort((a, b) => a.localeCompare(b))
  const sortedObj: { [key: string]: GlossaryItem[] } = {}

  sortedKeys.forEach((key) => {
    sortedObj[key] = result[key]
  })
  return sortedObj
}

function isEnglishLetter(char: string) {
  return (char >= "A" && char <= "Z") || (char >= "a" && char <= "z")
}
